// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.120-TSS-3119-mcastro-TASK-Remove-What-s-New-button-from-the-left-side-panel.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
